import AnalyticsUtil from 'utils/AnalyticsUtil';

export const onNewsFeedPage = () => window.location.href.includes('newsfeed');

export const pushNewsFeedAnalytics = (action, label) => {
    if (!onNewsFeedPage()) {
        return;
    }

    if (label) {
        AnalyticsUtil.push({
            event: 'track_event',
            category: 'News Feed Events',
            action,
            label
        });
    } else {
        AnalyticsUtil.push({
            event: 'track_event',
            category: 'News Feed Events',
            action
        });
    }
};
